// Spinner.js
import React, { useState } from 'react';
import './Spinner.css';  // We'll add some styles for the spinner in a separate file

const Spinner = ({ selectedValue, onSelect, options, disabled }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    if (!disabled) {
      setDropdownOpen(!dropdownOpen);
    }
  };

  return (
    <div className="spinner-container">
      <button
        className="spinner-button form-control shadow-sm"
        onClick={toggleDropdown}
        disabled={disabled}
      >
        {selectedValue === "" ? "Select Start" : selectedValue}
      </button>
      {dropdownOpen && (
        <div className="spinner-dropdown">
          {options.map((option) => (
            <div
              key={option}
              className="spinner-item"
              onClick={() => {
                onSelect(option);
                setDropdownOpen(false);
              }}
            >
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Spinner;
